import React, { Component, Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/cosmos/button/button';
import { Modal } from 'components/cosmos/v2/modal';
import { Checkbox } from 'components/input/checkbox';
import { Loader } from 'components/loader';
import { I18n } from 'components/translate';
import { DataHubPlayerService } from 'modules/app/services/datahub/player';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import styles from './playerModal.module.scss';

export default class PlayerModal extends Component {
  constructor(props) {
    super(props);

    this.confirmModal = this.confirmModal.bind(this);
  }

  static propTypes = {
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    addOnCost: PropTypes.string,
    isOpen: PropTypes.bool,
    bundleAddOnCost: PropTypes.string
  };

  state = {
    confirmed: false,
    showLoader: false
  };

  confirmModal = async () => {
    const { onConfirm } = this.props;

    this.setState({ showLoader: true });
    try {
      await onConfirm();
    } catch (error) {
      UiService.setAlertError('error_try_again');
      DataHubPlayerService.errorOnActivatePlayerInContentPageEvent();
    }
  };

  toggleConfirmed = () => {
    this.setState((prevState) => {
      if (prevState.confirmed) {
        DataHubPlayerService.disagreeTermsToActivatePlayerEvent();
      } else {
        DataHubPlayerService.agreeTermsToActivatePlayerEvent();
      }
      return { confirmed: !prevState.confirmed };
    });
  };

  render() {
    const { onClose, addOnCost, bundleAddOnCost } = this.props;
    const { confirmed, showLoader } = this.state;

    const benefits = Array.from({ length: 7 }).map(
      (_, index) => `advantage_${index + 1}`
    );

    return (
      <Modal
        title="player_modal.title"
        onClose={onClose}
        show
        className={styles.playerModal}
      >
        <Modal.Header className={classNames(styles.playerModalHeader, '_pb-4')}>
          <h2 className="_text-4 _text-lg-4 _font-weight-bold _mb-0">
            <I18n label="player_modal.title" />
          </h2>
          <span>
            <I18n label="player_modal.description" />
          </span>
        </Modal.Header>

        <Modal.Body className={classNames(styles.playerModalBody, '_mb-2')}>
          <div>
            <ul
              className={classNames(
                styles.advantagesContainer,
                '_text-2 _flex-column _mb-4, _d-flex _gap-2 _p-5 _rounded'
              )}
            >
              {benefits.map((benefit) => (
                <li
                  key={benefit}
                  className={classNames(
                    styles.advantage,
                    '_d-flex _gap-2 _align-items-center'
                  )}
                >
                  <FontAwesomeIcon icon={['fas', 'circle-check']} />
                  <I18n label={`player_modal.advantages.${benefit}`} html />
                </li>
              ))}
            </ul>

            <Checkbox
              onChange={this.toggleConfirmed}
              checked={confirmed}
              className={classNames(
                styles.termsCheckbox,
                '_d-flex _align-items-center _text-1'
              )}
            >
              <I18n
                label="player_modal.terms"
                data={{ value: addOnCost, value2: bundleAddOnCost }}
              />
            </Checkbox>
          </div>
        </Modal.Body>

        <Modal.Footer className="_d-flex _justify-content-end _pt-0">
          <Fragment>
            {showLoader ? (
              <Loader key="loader" />
            ) : (
              <Fragment>
                <Button
                  size="small"
                  onClick={this.confirmModal}
                  disabled={!confirmed}
                  className="hot-button hot-button--primary"
                >
                  <I18n label="general.enable" />
                </Button>
              </Fragment>
            )}
          </Fragment>
        </Modal.Footer>
      </Modal>
    );
  }
}
